export const actions = {
  LOGIN: 'LOGIN',
  REAUTHENTICATE: 'REAUTHENTICATE',
  LOGOUT: 'LOGOUT',

  login({email, code = false, onSuccess = () => {}, onError = () => {}}) {
    return {
      type: actions.LOGIN,
      email,
      code,
      onSuccess,
      onError
    }
  },
  reAuthenticate({onSuccess = () => {}, onError = () => {}} = {}) {
    return {
      type: actions.REAUTHENTICATE,
      onSuccess,
      onError
    }
  },
  logout() {
    return {
      type: actions.LOGOUT
    }
  }
}

export const AuthActions = actions
